export const DEVICE_TOKEN_PREFIX = "deviceToken:";
